import { Gender } from './enums/gender.enum';
import { ProfileOrganModel } from './organ.model';

export class ProfileModel {
  first_name: string = '';
  last_name: string = '';
  email: string = '';
  mobile_number: string = '';
  gender: Gender | null = null;
  linkedin: string = '';
  education_degree: number | null = null;
  field_of_study: string = '';
  charities: ProfileOrganModel[] = [];
  avatar_id?: string;
  is_afra: boolean;

  get isProfileIncomplete(): boolean {
    const basicComplete =
      !!this.first_name &&
      !!this.last_name &&
      !!this.mobile_number &&
      this.gender != null &&
      this.education_degree != null;

    const organsComplete = this.charities.every(
      (organ) =>
        !!organ.title &&
        organ.positions.length > 0 &&
        organ.cooperation_type != null,
    );

    return !this.is_afra && (!basicComplete || !organsComplete);
  }
}
